import PropTypes from 'prop-types';

export const ReviewCardPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string,
    text: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired
  })
); 